import { render } from "./PrimarySlide.vue?vue&type=template&id=ab2e96c8&scoped=true"
import script from "./PrimarySlide.vue?vue&type=script&lang=js"
export * from "./PrimarySlide.vue?vue&type=script&lang=js"

import "./PrimarySlide.vue?vue&type=style&index=0&id=ab2e96c8&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab2e96c8"]])

export default __exports__